(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsDocumentDownloadLink', rmsDocumentDownloadLink);

    function rmsDocumentDownloadLink() {
        return {
            restrict: 'E',
            controller: rmsDocumentDownloadLinkCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                downloadUrl: '=',
                downloadLabel: '@?',
                notifyLabel: '@?',
            },
            template: '<a ng-click="vm.click()" class="position-left" ng-bind-html="(vm.downloadLabel || \'Download\') | trustAsHtml"></a>',
        };
    }

    function rmsDocumentDownloadLinkCtrl(ActionManager) {
        const vm = this;
        this.$onInit = function() {
            vm.click = click;
        }

        function click() {
            ActionManager('notify', {
                'template': vm.notifyLabel || 'Please wait while we prepare your download...',
                'hasDelay': true,
                'delay'   : 2000,
                'type'    : 'success',
                'position': 'top center'
            });
            ActionManager('download', { route: vm.downloadUrl });
        }
    }
})();